__turbopack_context__.v({
  "carousel": "StateChartControls-module__WmImJq__carousel",
  "clearSelection": "StateChartControls-module__WmImJq__clearSelection",
  "controlsStack": "StateChartControls-module__WmImJq__controlsStack",
  "datazoneLink": "StateChartControls-module__WmImJq__datazoneLink",
  "desktopFilters": "StateChartControls-module__WmImJq__desktopFilters",
  "filterList": "StateChartControls-module__WmImJq__filterList",
  "filterTab": "StateChartControls-module__WmImJq__filterTab",
  "filterTabActive": "StateChartControls-module__WmImJq__filterTabActive",
  "group": "StateChartControls-module__WmImJq__group",
  "heading": "StateChartControls-module__WmImJq__heading",
  "iconHabitat": "StateChartControls-module__WmImJq__iconHabitat",
  "iconSpecies": "StateChartControls-module__WmImJq__iconSpecies",
  "label": "StateChartControls-module__WmImJq__label",
  "panel": "StateChartControls-module__WmImJq__panel",
  "panelOverlay": "StateChartControls-module__WmImJq__panelOverlay",
  "toggleActive": "StateChartControls-module__WmImJq__toggleActive",
  "toggleIcon": "StateChartControls-module__WmImJq__toggleIcon",
  "toggleInactive": "StateChartControls-module__WmImJq__toggleInactive",
  "toggleRow": "StateChartControls-module__WmImJq__toggleRow",
});
